import styled, {css} from 'styled-components'

export const StyledLastSyncedAt = styled.p(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs}
        color: ${palette.neutral['500']};
        font-weight: 400;
        white-space: nowrap;
    `
)
